import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on } from '../modules/events.js'
import Flickity from 'flickity'

class HeroSliderSection extends Section {
  initState() {
    return {
      index: 0
    }
  }

  init() {
    this.computed(() => this.indexChanged(this.state.index))
    this.sliderSetup()
  }

  sliderSetup() {
    this.slider = new Flickity(
      this.refs.sliderWrapper,
      {
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        wrapAround: true
      }
    )

    this.slider.on('change', (i) => {
      this.state.index = i
    })

    this.refs.indexes.forEach((el, i) => {
      on(el, 'pointerup', () => {
        this.slider.select(i)
      })
    })
  }

  indexChanged(value) {
    this.refs.indexes.forEach((el, i) => {
      if (i === value) {
        el.dataset.active = 1
      }
      else {
        el.dataset.active = 0
      }
    })
  }
}

register('heroslider', HeroSliderSection)
